module.exports = __webpack_public_path__ + "img/ppt.41703882.png";